/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMap = createReactComponent("map", "IconMap", [
  ["path", { d: "M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13", key: "svg-0" }],
  ["path", { d: "M9 4v13", key: "svg-1" }],
  ["path", { d: "M15 7v13", key: "svg-2" }]
]);

export { IconMap as default };
//# sourceMappingURL=IconMap.js.map
